module.exports = __webpack_public_path__ + "img/pointer-3.png";